export class TagCache {
  static indexCacheKey() {
    return 'tags';
  }
  static projectTagsCacheKey() {
    return 'project-tags';
  }

  static tagsMultiSelectFieldCacheKey() {
    return 'tags-multi-select-field-users';
  }

  static selectedTagsMultiSelectFieldCacheKey(fieldName: string) {
    return `tags-multi-select-field-users-${fieldName}`;
  }

  static searchableTagsCacheKey() {
    return 'searchable-tags';
  }

  static searchableSelectedTagsCacheKey() {
    return 'searchable-tags-selected';
  }

  static showCacheKey() {
    return 'tag';
  }
}
